export enum ProposalViewTabEnum {
  Search = 'search',
  HandleInput = 'handle-input',
  ExternalSource = 'external-source',
}
